//////////////////
// IMPORTS
//////////////////
// schema
import * as ISchema from "@schema";
// libraries
import React from "react";
import { IAvatarContainer, CreateInitialsPerson } from "./Avatar.d";
import { UserAvatar } from "@clockwise/web-commons/src/ui/UserAvatar";

/////////////////////
// COMPONENT
/////////////////////
export class AvatarPerson extends React.Component<IAvatarContainer> {
  private createProfileFromCalendarId = (
    person: CreateInitialsPerson | ISchema.IOrgPerson | null,
    backupCalendarId: string,
  ) => {
    let initials = "";
    if (person && person.__typename === "Person" && person.primaryEmail) {
      initials = person.primaryEmail;
    } else if (person && person.__typename === "OrgPerson" && person.primaryCalendarId) {
      initials = person.primaryCalendarId;
    } else {
      initials = backupCalendarId || "";
    }

    return {
      givenName: initials,
      familyName: null,
      externalImageUrl: null,
    };
  };

  // ~-~-~-~-~-~-~-
  // Rendering
  // ~-~-~-~-~-~-~-

  public render() {
    const {
      size,
      person,
      orgPerson,
      toolTipContent,
      backupCalendarId,
      showUserBadge = false,
      responseStatus,
      border = false,
      onClick,
    } = this.props;

    const userBadge = showUserBadge && !!(person?.isUser || orgPerson?.userId);
    const profile =
      person?.profile ||
      orgPerson?.profile ||
      this.createProfileFromCalendarId(person || orgPerson, backupCalendarId);

    return (
      <UserAvatar
        profile={profile}
        size={size}
        onClick={onClick}
        tooltip={toolTipContent}
        border={border}
        showUserBadge={userBadge}
        rsvp={responseStatus}
      />
    );
  }
}
